module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/phone-9f144e304d9b056f1471e5b8849b05aa.svg";